import {
  DefaultButton,
  FontIcon,
  Panel,
  PanelType,
  PrimaryButton,
  TextField,
} from "@fluentui/react";
import { useCallback, useEffect } from "react";
import { PanelHeader } from "../../../../components/Panel/PanelHeader";
import COLORES from "../../../../utils/theme/colores";
import { IEditarArea } from "../../../../Interfaces/IPERC/IArea";
import { useEditarArea } from "../../../../hooks/Iperc/Area/useEditarArea";
import { MensajeBar } from "../../../../components/generic/ManejoResponseMessage/MessageBar";
import IdicadorProgress from "../../../../components/generic/IndicadorProgress";

interface IPanelEditarArea {
  isOpen: boolean;
  onDismiss: () => void;
  modelRequest?: IEditarArea;
  loadData: () => void;
}

export const PanelEditarArea = (props: IPanelEditarArea) => {
  const {
    modelrequestEditar,
    onChangeTextField,
    handlerEditarArea,
    isSend,
    ocultarMensaje,
    response,
  } = useEditarArea(props.modelRequest, props.loadData);

  const onRenderFooterPanel = useCallback(
    () => (
      <>
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            justifyItems: "center",
            height: "5%",
            padding: "2opx",
            margin: "20px",
          }}
        >
          <div style={{ display: "flex" }}>
            <PrimaryButton onClick={() => handlerEditarArea()} text="Guardar" />
          </div>
          <div style={{ display: "flex" }}>
            <DefaultButton
              onClick={() => {
                props.onDismiss();
              }}
              text={"Salir"}
            />
          </div>
        </div>
      </>
    ),
    [props.onDismiss, handlerEditarArea]
  );
  const onRenderHeaderPanel = useCallback(
    () => (
      <>
        <PanelHeader
          key={"editar"}
          nameIconHeader="Edit"
          subTextHeader="Editar en Nombre de Área "
          textHeader="Editar Área"
        />
      </>
    ),
    []
  );

  useEffect(() => {
    if (!props.isOpen) {
      ocultarMensaje();
    }
  }, [props.isOpen]);

  return (
    <>
      <Panel
        isOpen={props.isOpen}
        onDismiss={props.onDismiss}
        isFooterAtBottom={true}
        onRenderHeader={onRenderHeaderPanel}
        onRenderFooter={onRenderFooterPanel}
        closeButtonAriaLabel="Close"
        type={PanelType.smallFixedFar}
        isLightDismiss
      >
        <>
          <MensajeBar
            response={response}
            ocultar={() => {
              ocultarMensaje();
            }}
          />

          {isSend === true ? (
            <>
              <IdicadorProgress
                isSend={isSend}
                subText="Espere un momento..."
              />
            </>
          ) : (
            <div className="ms-Grid-row">
              <div className="ms-Grid-col ms-lg12">
                <br />
                <TextField
                  label="Nombre de Área:"
                  value={modelrequestEditar.nombre}
                  onChange={(e, value) =>
                    onChangeTextField(e, value, props.modelRequest?.areaId)
                  }
                  onRenderPrefix={(arg) => (
                    <FontIcon
                      iconName="Rename"
                      style={{ color: COLORES.Bases.primary }}
                    />
                  )}
                  placeholder="Nombre de Area *"
                />
              </div>
            </div>
          )}
        </>
      </Panel>
    </>
  );
};
